/*
 * product-finder.js - code for product finder
 *   currently on first page
 */

jQuery(document).ready(($) => {
    const data = window.CLOROX_GLOBAL.ProductFinderData;

    const $finder = $('.js-product-finder');

    // fn to update other select when item selected
    function updateSelect(val, $controlToUpdate, field, otherfield) {
        $controlToUpdate.find('option').attr('disabled', false).show();
        if (val === 0) {
            return;
        }
        const updateArray = [];

        // find values to allow in otehr select
        $.each(data, (i, product) => {
            if (product[field].indexOf(val) !== -1) {
                $.each(product[otherfield], (i2, id) => {
                    if (updateArray.indexOf(id) === -1) {
                        updateArray.push(id);
                    }
                });
            }
        });

        // actually update control
        $('option', $controlToUpdate).each((i, el) => {
            const $this = $(el);
            const value = parseInt($this.val(), 10);
            if (value && updateArray.indexOf(value) === -1) {
                $this.attr('disabled', true).hide();
            }
        });
    }

    // select handling
    //  update other select when change is made
    const $selectType = $finder
        .find('.js-select-type')
        .on('change', () => {
            const val = parseInt($selectType.val(), 10);
            // eslint-disable-next-line no-use-before-define
            updateSelect(val, $selectWhere, 'types', 'where');
        })
        .val(0);
    const $selectWhere = $finder
        .find('.js-select-where')
        .on('change', () => {
            const val = parseInt($selectWhere.val(), 10);
            updateSelect(val, $selectType, 'where', 'types');
        })
        .val(0);

    // go to products page showing selected cats
    $('.js-go-button').on('click', function onClick() {
        const cats = [];
        let slug = $selectType.find(':selected').data('slug');
        if (slug) {
            cats.push(slug);
        }
        slug = $selectWhere.find(':selected').data('slug');
        if (slug) {
            cats.push(slug);
        }

        let href = $(this).attr('href');
        if (cats.length >= 1) {
            href += `${translatedStrings.product_category}/${cats.sort().join('/')}/`;
        }

        window.location.href = href;

        return false;
    });
});
